import PropTypes from "prop-types";

import AudioVideoSettingsContainer from "./container";
import WebcamItem from "./webcam_item";
import MicrophoneItem from "./microphone_item";
import SpeakerItem from "./speaker_item";
import PhoneItem from "./phone_item";

function AudioVideoSettings({
  allowPhone,
  onChangeDevices,
  renderMessaging,
  onClose,
  selectedDevices,
  meetingParticipant,
  initWithPhoneOpen,
}) {
  const phoneItem = allowPhone ? (
    <PhoneItem
      onChangeDevices={onChangeDevices}
      selectedDevices={selectedDevices}
      onHangUp={onClose}
      meetingParticipant={meetingParticipant}
    />
  ) : null;

  return (
    <AudioVideoSettingsContainer
      webcamItem={
        <WebcamItem onChangeDevices={onChangeDevices} selectedDevices={selectedDevices} autoFocus />
      }
      phoneItem={phoneItem}
      renderMessaging={renderMessaging}
      microphoneItem={
        <MicrophoneItem onChangeDevices={onChangeDevices} selectedDevices={selectedDevices} />
      }
      speakerItem={
        <SpeakerItem onChangeDevices={onChangeDevices} selectedDevices={selectedDevices} />
      }
      initWithPhoneOpen={Boolean(phoneItem && initWithPhoneOpen)}
      closeContainer={onClose}
    />
  );
}

AudioVideoSettings.propTypes = {
  allowPhone: PropTypes.bool,
  onChangeDevices: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedDevices: PropTypes.shape({
    webcam: PropTypes.string,
    phone: PropTypes.string,
    microphone: PropTypes.string,
    speaker: PropTypes.string,
  }).isRequired,
  meetingParticipant: PropTypes.object,
  renderMessaging: PropTypes.func,
  initWithPhoneOpen: PropTypes.bool,
};

export default AudioVideoSettings;
